import * as React from "react";

import TextInputRA from "../components/TextInputRA";
import LayoutContainer from "../components/LayoutContainer";
import { Box, Grid } from "@material-ui/core";
import LeftGridCreate from "../components/LeftGridCreate";
import RightGridCreate from "../components/RightGridCreate";
import StatusInput from "../components/StatusInput";
import GeneralSelect from "../components/GeneralSelect";
import SubCategoryValidation from "../../../ValidationRules/SubCategoryValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
/*
{
  "locale": "en-US",
  "type": "Product",
  "name": "Ear Pod",
  "desc": "description",
  "base_price": 1000,
  "retail_price": 10000,
  "currency": "THB",
  "unit": "Piece",
  "hashtags[]": [
    "#iphone"
  ],
    "status": "Active",
  "sub_category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
*/

const SubcategoryCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate {...props} validate={SubCategoryValidation}>
        <SfBreadcrumbs path="Management/Sub-categories/New Sub-Category" />
        <Box style={{ margin: 50 }}>
          <TextInputRA required label="Subcategory name" source="name" />
          <TextInputRA label="Description" source="desc" />
          <GeneralSelect
            label="Category"
            require={true}
            source="category_id"
            resource="product-categories"
          />
          <StatusInput />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create Category">
      <SimpleForm>
        <TextInputRA label="Subcategory name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <ReferenceArrayInput
          label="Category"
          source="category_id"
          reference="product-categories"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <HiddenInputRA source="status" initialValue="Active" />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.Category" write />
  </LayoutContainer>
);

export default SubcategoryCreate;
